<template>
    <div class="visual-novel-component-container">
        <div class="visual-novel-frame">
            <div class="inicial-page animate__animated">
                <img src="https://1.bp.blogspot.com/-qn14_M4IDhE/XYWKuIxbzCI/AAAAAAAAb1s/duPwzP0HSJMh3UHsEO_EvUXDFTgxyvKiACLcBGAsYHQ/s2560/anime-sunset-scene-b8-2560x1440.jpg" class="inicial-page-background" />
                <div class="informations-div animate__animated">
                    <div class="logo">
                        <router-link to="/">
                            <img src="../assets/power-stones-logo.png" class="inicial-logo">
                        </router-link>
                    </div>
                    <div class="actions-menu">
                        <div class="actions-menu-container">
                            <i class="fas fa-arrow-left" id="return-button" v-on:click="resetMenuNavigation()"></i>
                            <ul class="main-menu animate__animated animate__faster">
                                <li v-on:click="goToHistory(0)">Novo jogo</li>
                                <li v-if="userNovelStatus.last_level_completed > 0" v-on:click="goToHistory(userNovelStatus.last_level_completed)">Continuar</li>
                                <li v-on:click="goToOptions()">Opções</li>
                                <li>Sobre</li>
                            </ul>
                            <ul class="options-menu animate__animated animate__faster">
                                <li v-on:click="toggleFullscreen()" id="toggle-fullscreen">Tela cheia</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="hero-div animate__animated">
                    <img src="https://uploaddeimagens.com.br/images/004/568/160/full/anime-waifu-test.png?1691349682">
                </div>
            </div>
            <div class="begin-chapter animate__animated">
                <img :src="currentLevel.level_background" class="begin-chapter-background" />
                <div class="begin-chapter-container">
                    <i class="fas fa-arrow-left" id="return-menu-button" v-on:click="returnToMenu()"></i>
                    <div class="logo animate__animated">
                        <img src="../assets/power-stones-logo.png" class="inicial-logo">
                    </div>
                    <div class="level-informations animate__animated">
                        <p><i>{{ currentLevel.subtitle }}</i></p>
                        <h1>{{ currentLevel.title }}</h1>
                        <div class="play-button-container" v-on:click="beginChapter()">
                            <i class="fas fa-play-circle"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chapter animate__animated" v-if="currentScene != null">
                <transition name="fade" v-if="currentScene.have_next_scene == 0">
                    <img :src="currentScene.background" :key="currentScene.id_scene" class="chapter-background" />
                </transition>
                <img v-else :src="currentScene.background" :key="currentScene.id_scene" class="chapter-background" />
                
                <div class="chapter-container">
                    <div class="chapter-name">
                        <img src="../assets/power-stones-logo.png">
                        <p>{{ currentLevel.chapter_id }} - {{ currentLevel.title }}</p>
                    </div>
                    <div class="interactive-scene-container">
                        <div class="characters">
                            <img v-for="(character, index) in currentScene.characters" 
                                :key="index" 
                                :src="character.src"
                                :class="{
                                    'character-active': character.active === 1,
                                    'from-right': character.direction === 'right',
                                    'from-left': character.direction === 'left',
                                    'from-right-2': character.direction === 'right2',
                                    'from-left-2': character.direction === 'left2',
                                    'without-animation': character.withoutAnimation === 1
                                }"
                            />
                        </div>
                        <div class="interaction-container" :style="currentScene != null && currentScene.is_final_scene != 0  ? 'display: none;' : 'display: flex;'">
                            <h6>{{ currentScene.title }}</h6>
                            <p class="scene-text" id="scene-text" :style="currentScene.text == '' ? 'display: none;' : ''"></p>
                            <div class="choice-container" :style="currentScene.text == '' && currentScene.text_choice_1 != '' ? 'display: block;' : 'display: none;'">
                                <ul>
                                    <li v-on:click="chooseChoice(1)">
                                        <p class="scene-text">{{ currentScene.text_choice_1 }}</p>
                                    </li>
                                    <li v-on:click="chooseChoice(2)">
                                        <p class="scene-text">{{ currentScene.text_choice_2 }}</p>
                                    </li>
                                </ul>
                            </div>
                            <i class="fas fa-caret-right next-scene" v-on:click="nextScene()" v-if="currentScene.text_choice_1 == '' && allowToNextScene"></i>
                        </div>
                        <i class="fas fa-caret-right next-scene-final" v-on:click="nextScene()" :style="currentLevel != null && currentScene.is_final_scene != 0 ? 'display: block;' : 'display: none;'"></i>
                    </div>
                </div>
            </div>
            <div class="end-chapter animate__animated">
                <img :src="currentLevel.level_background" class="end-chapter-background" />
                <div class="end-chapter-container">
                    <i class="fas fa-home" id="return-menu-button" v-on:click="returnToMenu()"></i>
                    <div class="logo animate__animated">
                        <img src="../assets/power-stones-logo.png" class="inicial-logo">
                    </div>
                    <div class="end-level-informations animate__animated">
                        <h1>Fim do capítulo</h1>
                        <div class="actions-container">
                            <div class="action-item">
                                <i class="fas fa-redo-alt" v-on:click="restartChapter()"></i>
                                <p>Reiniciar capítulo</p>
                            </div>
                            <div class="action-item">
                                <i class="fas fa-forward"></i>
                                <p>Próximo Capítulo</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery';

export default {
    name: "visualNovelComponent",
    data() {
        return {
            allowToNextScene: false,
            currentScene: null,
            userNovelStatus: {
                user_id: 1,
                last_level_completed: 0,
                first_phase_choice: 0
            },
            currentLevel: {
                chapter_id: 1,
                subtitle: "Capítulo 1",
                title: "Jack! Mike! Tony!",
                is_final_level: 1,
                level_background: "https://images3.alphacoders.com/132/1322308.jpeg",
                scenes: [
                    {
                        id_scene: 1,
                        background: "https://i.pinimg.com/originals/3c/7a/fc/3c7afc1b68c0f8cc367dd9d0f1f383de.jpg",
                        characters: [
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 1,
                                direction: "left",
                                entrance_animation: 1,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            }
                        ],
                        title: "Ana",
                        text: "Como você pode fazer isso, Jack? Eu ... Eu confiei em você! Eu vivia com desespero e desgosto desse doutor Carlos, e agora você faz isso? A gente não pode confiar em ninguém mais!",
                        is_final_scene: 0,
                        have_next_scene: 0,
                        next_scene_id: 2,
                        choice_1_next_scene_id: 0,
                        choice_2_next_scene_id: 0,
                        text_choice_1: "",
                        text_choice_2: ""
                    },
                    {
                        id_scene: 2,
                        background: "https://img.freepik.com/fotos-premium/tarde-por-do-sol-ceu-nuvens-paisagem-anime-background-generative-ai_117038-3743.jpg?w=2000",
                        characters: [
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 0,
                                direction: "left",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 1
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 1,
                                direction: "right",
                                entrance_animation: 1,
                                exit_animation: 0,
                                withoutAnimation: 0
                            }
                        ],
                        title: "Jack",
                        text: "Você entendeu errado Ana! A pedra está te controlando! Por favor ... Volte para si!",
                        is_final_scene: 0,
                        have_next_scene: 1,
                        next_scene_id: 3,
                        choice_1_next_scene_id: 0,
                        choice_2_next_scene_id: 0,
                        text_choice_1: "",
                        text_choice_2: ""
                    },
                    {
                        id_scene: 3,
                        background: "https://img.freepik.com/fotos-premium/tarde-por-do-sol-ceu-nuvens-paisagem-anime-background-generative-ai_117038-3743.jpg?w=2000",
                        characters: [
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 0,
                                direction: "left",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 1
                            },
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 1,
                                direction: "left2",
                                entrance_animation: 1,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 0,
                                direction: "right",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 1
                            }
                        ],
                        title: "Jack",
                        text: "Eu sei que você ainda está aí, por favor, escute minha voz!",
                        is_final_scene: 0,
                        next_scene_id: 4,
                        have_next_scene: 1,
                        choice_1_next_scene_id: 0,
                        choice_2_next_scene_id: 0,
                        text_choice_1: "",
                        text_choice_2: ""
                    },
                    {
                        id_scene: 4,
                        background: "https://img.freepik.com/fotos-premium/tarde-por-do-sol-ceu-nuvens-paisagem-anime-background-generative-ai_117038-3743.jpg?w=2000",
                        characters: [
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 0,
                                direction: "left",
                                entrance_animation: 0,
                                exit_animation: 1,
                                withoutAnimation: 0
                            },
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 0,
                                direction: "left2",
                                entrance_animation: 0,
                                exit_animation: 1,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 1,
                                direction: "right",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 1
                            }
                        ],
                        title: "Você vai terminar com ela?",
                        text: "",
                        is_final_scene: 0,
                        next_scene_id: 0,
                        choice_1_next_scene_id: 5,
                        choice_2_next_scene_id: 0,
                        have_next_scene: 0,
                        text_choice_1: "Sim",
                        text_choice_2: "Não"
                    },
                    {
                        id_scene: 5,
                        background: "https://i.pinimg.com/originals/b5/fd/3f/b5fd3fbe984103e08b9482471484394b.gif",
                        characters: [
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "",
                                active: 0,
                                direction: "",
                                entrance_animation: 0,
                                exit_animation: 0,
                                withoutAnimation: 0
                            },
                            {
                                src: "https://uploaddeimagens.com.br/images/004/568/129/full/taiga-teste.png?1691342202",
                                active: 0,
                                direction: "right",
                                entrance_animation: 0,
                                exit_animation: 1,
                                withoutAnimation: 0
                            }
                        ],
                        title: "",
                        text: "",
                        is_final_scene: 1,
                        next_scene_id: 0,
                        choice_1_next_scene_id: 0,
                        choice_2_next_scene_id: 0,
                        have_next_scene: 0,
                        text_choice_1: "",
                        text_choice_2: ""
                    }
                ]
            }
        }
    },
    methods: {
        chooseChoice: function (choiceNumber) {
            console.log(choiceNumber)
            if (choiceNumber == 1) {
                this.nextScene(this.currentScene.choice_1_next_scene_id);
            } else if (choiceNumber == 2) {
                this.nextScene(this.currentScene.choice_2_next_scene_id);
            }
            
        },
        mountCharactersAnimationsClasses: function () {
            let interval = setInterval(() => {
                if ($(".chapter").is(":visible")) {
                    clearTimeout(interval);
                    let characters = this.currentScene.characters;
                    let charactersElements = $(".characters img");
                    for (let i = 0; i < characters.length; i++) {
                        let currentCharacter = characters[i];
                        let classText = "";
                        if (currentCharacter.entrance_animation == 1) {
                            classText = "entrance";
                        }
                        if (currentCharacter.exit_animation == 1) {
                            classText = "exit";
                        }
                        $(charactersElements[i]).addClass(classText);
                    }  
                }
            }, 10)
        },  
        restartChapter: function () {
            this.resetAllContainers();
            let endChapter = $(".end-chapter");
            endChapter.addClass("animate__fadeOut");
            setTimeout(() => {
                endChapter.hide();
                this.beginChapter(true);
            }, 300)
        },
        beginChapter: function (fromFinal = false) {
            this.resetAllContainers();
            this.currentScene = this.currentLevel.scenes[0];

            setTimeout(() => {
                let beginChapter = $(".begin-chapter");
                let chapter = $(".chapter");
                if (!fromFinal) {
                    beginChapter.addClass("animate__fadeOut");
                    setTimeout(() => {
                        beginChapter.hide();
                    }, 300);
                }

                setTimeout(() => {
                    chapter.show().css("opacity", 0);
                    setTimeout(() => {
                        chapter.addClass("animate__fadeIn").css("opacity", 1);
                        setTimeout(() => {
                            this.animateTextWithLineBreaks(this.currentScene.text);
                            this.mountCharactersAnimationsClasses();
                        }, 300)
                    }, 1)
                }, 300)
            }, 1)
        },
        animateTextWithLineBreaks: function (text) {
            let self = this;
            let textArray = text.split(' ');
            let lineText = '';
            let currentLine = this.createSpanWithAnimation('');
            let container = document.getElementById('scene-text');
            container.innerHTML = "";
            
            self.allowToNextScene = false;

            function addWordToLine(wordIndex) {
                if (wordIndex < textArray.length) {
                    const word = textArray[wordIndex];
                    const newText = lineText === '' ? word : lineText + ' ' + word;
                    currentLine.textContent = newText;

                    if (currentLine.offsetWidth > container.offsetWidth) {
                        container.appendChild(currentLine);
                        lineText = word;
                        currentLine = this.createSpanWithAnimation(lineText);
                    } else {
                        lineText = newText;
                    }

                    container.appendChild(currentLine);
                    setTimeout(() => addWordToLine(wordIndex + 1), 1); // 100ms de atraso entre as palavras

                    if (wordIndex == textArray.length - 1) {
                        self.allowToNextScene = true;
                    }
                }
            }

            addWordToLine(0);
        },
        createSpanWithAnimation: function (text) {
            const span = document.createElement('span');
            span.classList.add('text');
            span.textContent = text;
            return span;
        },
        nextScene: function (sceneId) {
            this.allowToNextScene = false;
            if (this.currentScene.is_final_scene == 1 || (sceneId != undefined && sceneId == 0)) {
                this.endChapter();
                return;
            }

            let nextSceneId = this.currentScene.next_scene_id;

            if (sceneId != undefined) {
                nextSceneId = sceneId;
            }

            this.currentScene = this.currentLevel.scenes.find(obj => obj.id_scene == nextSceneId);

            setTimeout(() => {
                setTimeout(() => {
                    this.animateTextWithLineBreaks(this.currentScene.text);
                    this.mountCharactersAnimationsClasses();
                }, 1)
            }, 300)
        },  
        resetAllContainers: function (from_menu = false) {
            let inicialPage = $(".inicial-page");
            let informationsDiv = $(".informations-div");
            let heroDiv = $(".hero-div");
            let beginChapter = $(".begin-chapter");
            let beginChapterLogo = $(".begin-chapter-container .logo");
            let endChapter = $(".end-chapter");
            let endChapterLogo = $(".end-chapter-container .logo");
            let endLevelInformations = $(".end-level-informations");
            let chapter = $(".chapter");

            if (!from_menu) {
                inicialPage.removeClass("animate__fadeOut").removeClass("animate__fadeIn");
                informationsDiv.removeClass("animate__fadeOutLeft").removeClass("animate__fadeInRight");
                heroDiv.removeClass("animate__fadeOutRight").removeClass("animate__fadeInLeft");
            }

            beginChapter.removeClass("animate__fadeIn").removeClass("animate__fadeOut");
            beginChapterLogo.removeClass("animate__fadeInDown").removeClass("animate__fadeOutUp");
            endChapter.removeClass("animate__fadeIn").removeClass("animate__fadeOut");
            endChapterLogo.removeClass("animate__fadeInDown");
            endLevelInformations.removeClass("animate__fadeIn");
            chapter.removeClass("animate__fadeIn").removeClass("animate__fadeOut");

            this.currentScene = null;
        },
        goToHistory: function (history_id) {
            console.log(history_id)
            this.resetAllContainers(true);
            let inicialPage = $(".inicial-page");
            let informationsDiv = $(".informations-div");
            let heroDiv = $(".hero-div");
            let beginChapter = $(".begin-chapter");
            let beginChapterLogo = $(".begin-chapter-container .logo");
            let levelInformations = $(".level-informations");

            informationsDiv.addClass("animate__fadeOutLeft");
            heroDiv.addClass("animate__fadeOutRight");
            setTimeout(() => {
                inicialPage.addClass("animate__fadeOut");
                setTimeout(() => {
                    inicialPage.hide();
                    beginChapter.show();
                    setTimeout(() => {
                        beginChapter.addClass("animate__fadeIn");
                        setTimeout(() => {
                            beginChapterLogo.addClass("animate__fadeInDown").css("opacity", 1);
                            setTimeout(() => {
                                levelInformations.css("opacity", 1);
                            }, 500)
                        }, 300);
                    }, 1)
                }, 500);
            }, 300);
        },
        endChapter: function () {
            let chapter = $(".chapter");
            let endChapter = $(".end-chapter");
            let endChapterLogo = $(".end-chapter-container .logo");
            let endLevelInformations = $(".end-level-informations");
            chapter.addClass("animate__fadeOut");
            setTimeout(() => {
                chapter.hide();
                endChapter.show();
                setTimeout(() => {
                    endChapter.addClass("animate__fadeIn");
                    setTimeout(() => {
                        endChapterLogo.addClass("animate__fadeInDown");
                        setTimeout(() => {
                            endLevelInformations.addClass("animate__fadeIn");
                            this.currentScene = null;
                        }, 200)
                    }, 200)
                }, 1)
            }, 300)
        },
        returnToMenu: function () {
            this.resetAllContainers();
            
            let inicialPage = $(".inicial-page");
            let informationsDiv = $(".informations-div");
            let heroDiv = $(".hero-div");
            let beginChapter = $(".begin-chapter");
            let beginChapterLogo = $(".begin-chapter-container .logo");
            let levelInformations = $(".level-informations");
            let endChapter = $(".end-chapter");

            levelInformations.css("opacity", 0);
            informationsDiv.css("opacity", 0);
            heroDiv.css("opacity", 0);
            setTimeout(() => {
                beginChapterLogo.addClass("animate__fadeOutUp").css("opacity", 0);
                setTimeout(() => {
                    beginChapter.addClass("animate__fadeOut");
                    endChapter.addClass("animate__fadeOut");
                    setTimeout(() => {
                        beginChapter.hide();
                        endChapter.hide();
                        inicialPage.show().css("opacity", 0);
                        setTimeout(() => {
                            inicialPage.addClass("animate__fadeIn");
                            setTimeout(() => {
                                informationsDiv.addClass("animate__fadeInLeft").css("opacity", 1);
                                heroDiv.addClass("animate__fadeInRight").css("opacity", 1);
                            }, 400);
                        }, 1)
                    }, 400)
                }, 400);
            }, 100);
        },
        goToOptions: function () {
            let mainMenu = $(".main-menu");
            let optionsMenu = $(".options-menu");
            let returnButton = $("#return-button");
            
            this.resetMenuClass();

            mainMenu.addClass("animate__fadeOutLeft");
            setTimeout(() => {
                mainMenu.hide();
                optionsMenu.show();
                setTimeout(() => {
                    optionsMenu.addClass("animate__fadeInRight").css("opacity", 1);
                    returnButton.show();
                }, 1)
            }, 200);
        },
        resetMenuClass: function () {
            let mainMenu = $(".main-menu");
            let optionsMenu = $(".options-menu");

            mainMenu.removeClass("animate__fadeInLeft").removeClass("animate__fadeOutLeft");
            optionsMenu.removeClass("animate__fadeInRight").removeClass("animate__fadeOutRight");
        },
        resetMenuNavigation: function () {
            let mainMenu = $(".main-menu");
            let optionsMenu = $(".options-menu");
            let returnButton = $("#return-button");

            this.resetMenuClass();

            optionsMenu.addClass("animate__fadeOutRight");
            setTimeout(() => {
                mainMenu.show();
                returnButton.hide();
                optionsMenu.hide();
                setTimeout(() => {
                    mainMenu.addClass("animate__fadeInLeft");
                }, 1)
            }, 200);
        },
        toggleFullscreen: function () {
            let toggleFullscreen = $("#toggle-fullscreen");
            toggleFullscreen.toggleClass("active");

            if (toggleFullscreen.hasClass("active")) {
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) { /* Firefox */
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) { /* Chrome, Safari e Opera */
                    document.documentElement.webkitRequestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) { /* IE/Edge */
                    document.documentElement.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) { /* Firefox */
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) { /* Chrome, Safari e Opera */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE/Edge */
                    document.msExitFullscreen();
                }
            }
        }
    },
    mounted: function () {
        $(document).on("keyup", (e) => {
            if (this.allowToNextScene) {
                e.preventDefault();
                if (e.keyCode == "32") {
                    this.nextScene();
                }
            }
        })

        $(document).on("fullscreenchange", function() {
            let headerContainer = $(".header-container");
            if (document.fullscreenElement) {
                headerContainer.hide();
            } else {
                headerContainer.show();
            }
        });
    }
}
</script>
<style scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#return-menu-button {
    cursor: pointer;
    color: var(--white);
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 2;
}

.options-menu {
    display: none;
    opacity: 0;
}
.visual-novel-frame {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: white;
}

.inicial-page, .begin-chapter, .end-chapter, .chapter {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
    font-size: 30px;
}

.begin-chapter, .end-chapter, .chapter {
    display: none;
}

.inicial-page-background, .begin-chapter-background, .end-chapter-background, .chapter-background {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    transition: all 0.4s;
}

.informations-div, .hero-div {
    min-width: 50%;
    width: 95vh;
    max-width: 50%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    padding: 2rem;
}

.begin-chapter-container, .end-chapter-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    padding: 2rem;
    height: 100%;
}

    .begin-chapter-container .logo, .end-chapter-container .logo {
        opacity: 0;
    }

.chapter-container {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
}

.chapter-name {
    display: flex;
    align-items: center;
    color: var(--white);
    background: rgba(0, 0, 0, 0.5);
    width: fit-content;
    padding: 0.5rem .7rem;
    border-radius: 0 0 20px 0;
    z-index: 3;
    position: relative;
}

    .chapter-name img {
        width: 3em;
    }

    .chapter-name p {
        margin: 0;
        margin-left: 10px;
        font-size: .6em;
    }

.interaction-container {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 1rem;
    width: calc(8rem + 50vw);
    height: 14vh;
    max-height: 500px;
    min-height: 110px;
    background: rgba(255, 255, 255, 0.7);
    padding: 0.3em;
    border-radius: 20px;
    box-shadow: inset 0 0 0 0.1em var(--white);
    border: 0.1em solid transparent;
    outline: 0.1em solid var(--primary-color);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

    .interaction-container h6 {
        font-size: .7em;
        font-weight: bold;
        margin-bottom: 1vh;
    }

.scene-text {
    font-size: .6em;
    display: inline-block;
    margin: 0;
    line-height: 100%;
}

.choice-container {
    display: flex;
    flex-direction: column;
}

    .choice-container ul {
        padding-left: 0.8em;
    }

        .choice-container ul li {
            cursor: pointer;
            padding: 0.2rem;
            width: 30%;
            line-height: .6em;
        }

            .choice-container ul li:hover {
                background: rgba(0, 0, 0, 0.1);
            }

@keyframes typing {
    from { width: 0; }
    to { width: 100%; }
}

.next-scene {
    position: absolute;
    right: 10px;
    bottom: 5px;
    cursor: pointer;
    color: #852b80;
}

.next-scene-final {
    color: var(--white);
    font-size: 3em;
    position: absolute;
    right: 2vw;
    bottom: 2vh;
    cursor: pointer;
}

.characters {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

    .characters img {
        position: absolute;
        width: 12vw;
        bottom: 0;
        filter: brightness(0.7);
    }

.character-active {
    filter: brightness(1) !important;
}

@keyframes returnLeft {
    0% {
        transform: translateX(0vw);
    }
    100% {
        transform: translateX(-40vw);
    }
}

@keyframes returnRight {
    0% {
        transform: translateX(0vw);
    }
    100% {
        transform: translateX(40vw);
    }
}

.from-right-2 {
    bottom: 5vh !important;
    right: 16vw;
    transform: translateX(40vw);
}

.from-left-2 {
    bottom: 5vh !important;
    left: 16vw;
    transform: translateX(-40vw);
}

.from-right {
    right: 2vw;
    transform: translateX(20vw);
}

.from-left {
    left: 2vw;
    transform: translateX(-20vw);
}

.from-right.entrance, .from-right-2.entrance {
    transition: transform .7s ease-in-out;
    transform: translateX(0) !important;
}

.from-left.entrance, .from-left-2.entrance {
    transition: transform .7s ease-in-out;
    transform: translateX(0) !important;
}

.from-left.exit, .from-left-2.exit {
    animation-name: returnLeft;
    animation-duration: .7s;
    animation-fill-mode: forwards;
}

.from-right.exit, .from-right-2.exit {
    animation-name: returnRight;
    animation-duration: .7s;
    animation-fill-mode: forwards;
}
.without-animation {
    transform: translateX(0) !important;
    transition: none !important;
    animation: none !important;
}

.level-informations, .end-level-informations {
    color: var(--white);
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: fit-content;
    height: fit-content;
    opacity: 0;
    transition: all 0.4s;
}

    .level-informations p {
        margin: 0;
    }

.actions-container {
    display: flex;
    margin-top: .5em;
}

.action-item {
    margin: 0 1em;
    width: 8em;
    height: 4em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

    .action-item p {
        margin: 0;
        position: absolute;
        bottom: 0;
    }

    .action-item i {
        font-size: 2em;
        cursor: pointer;
        transition: all 0.4s;
        position: absolute;
        top: 0;
    }

        .action-item i:hover {
            font-size: 2.5em;
        }

.play-button-container {
    width: calc(3em + 5vw);
    height: calc(3em + 5vw);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
}

    .play-button-container > i {
        color: var(--white);
        font-size: calc(3em + 5vw);
        transition: all 0.4s;
        cursor: pointer;
        margin-top: 1vh;
    }

        .play-button-container > i:hover {
            font-size: calc(3.5em + 5vw);
        }

.hero-div {
    align-items: center;
    justify-content: center;
}

    .hero-div img {
        width: calc(100% - 6rem);
        max-width: 600px;
    }

@media (max-width: 970px) {
    .visual-novel-frame {
        width: 100vw;
        height: 100vh;
        margin: 0;
        border-radius: 0;
    }
}

@media (max-width: 450px) {
    .hero-div {
        display: none;
    }
}

.actions-menu-container {
    position: relative;
}


#return-button {
    position: absolute;
    top: -50px;
    left: 10px;
    color: var(--white);
    cursor: pointer;
    display: none;
}


.actions-menu {
    color: var(--white);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

    .actions-menu ul {
        list-style: none;
        width: 100%;
    }

    .actions-menu ul li {
        padding: .5rem;
        cursor: pointer;
        max-width: 250px;
        transition: all 0.4s;
    }

        .actions-menu ul li:hover, .active {
            background: rgba(255, 255, 255, 0.2);
            padding-left: 1rem !important;
        }
</style>